/**
 * MK Story — API 클라이언트
 * 백엔드 FastAPI 서버와 통신합니다.
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 120000, // 2분 (Claude 응답 대기)
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * URL로 기사 변환 요청
 */
export async function transformByUrl(params) {
  const response = await api.post('/api/transform/url', params);
  return response.data;
}

/**
 * 텍스트로 기사 변환 요청
 */
export async function transformByText(params) {
  const response = await api.post('/api/transform/text', params);
  return response.data;
}

/**
 * 팩트 검증 요청
 */
export async function factCheck(params) {
  const response = await api.post('/api/fact-check', params);
  return response.data;
}

/**
 * 서버 상태 확인
 */
export async function healthCheck() {
  const response = await api.get('/api/health');
  return response.data;
}

export default api;
